<template>
    <div
        class="dropdown"
        :class="{ 'is-active' : active, 'is-right' : rightAligned }"
        @click="toggle"
        ref="dropdown"
    >

        <div class="dropdown-trigger">
            <button class="button" :class="clazz" aria-haspopup="true" aria-controls="dropdown-menu" >
                <span v-if="value">
                    {{localRender(value)}}
                </span>
                <span class="icon is-small">
                    <i class="m-r-xs m-l-xs" :class="active ? icons.active_class : icons.inactive_class" aria-hidden="true"></i>
                </span>
            </button>
        </div>

        <div class="dropdown-menu" id="dropdown-menu" role="menu">
            <div class="dropdown-content">
                <div
                    v-for="(selection, index) in availableSelections"
                    :key="index"
                >
                    <a
                        class="dropdown-item"
                        :class="{'is-active' : localSelected(selection), 'is-disabled' : selection.disabled }"
                        @click="localValue = selection"
                    >
                        {{localRender(selection)}}
                    </a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name : 'DropdownSelection',
    data () {
        return {
            active : false,
        };
    },
    props : {
        selections : {
            type : Array,
            required : true,
        },
        clazz : {
            type : String,
            required : false,
            default : ''
        },
        rightAligned : {
            type : Boolean,
            default : false,
        },
        value : null,
        selected : {
            type : Function,
            required : false,
        },
        defaultSelection : {
            type : Object,
            required : false,
        },
        render : {
            type : Function,
            required : false,
        },
    },
    computed : {
        localValue : {
            get () { return this.value },
            set (localValue) {
                this.$emit('input', localValue);
                this.$emit('change', localValue);
            },
        },
        availableSelections () {
            const selections = [];
            if(this.defaultSelection){
                selections.push(this.defaultSelection);
            }
            return selections.concat(this.selections);
        },
        icons(){
            return {
                active_class : 'fa fa-angle-up',
                inactive_class : 'fa fa-angle-down'
            }
        },
    },
    methods : {
        toggle () {
            if(!this.active){
                this.active = true;
                window.addEventListener('click', this.close, { passive : true })
            } else {
                this.active = false;
                window.removeEventListener('click', this.close);
            }
        },
        close (event) {
            if(!this.$refs.dropdown.contains(event.target)){
                this.active = false;
                window.removeEventListener('click', this.close);
            }
        },
        localSelected(selection){
            if(this.selected){
                return this.selected(this.value, selection);
            }
            return this.value && this.value.id === selection.id;
        },
        localRender (selection) {
            if(this.render){
                return this.render(selection);
            }
            return selection.name;
        },
    },
};
</script>
